import { IBooking } from '../../models/IBooking';
import { getIsFutureBooking } from './getIsFutureBooking';

export function getIsFullAmendAllowed(booking: IBooking) {
	return getIsFutureBooking(booking) && booking.status !== 'canceled';
}
